module.exports = __webpack_public_path__ + "static/media/bookmark0-w.6974246a.svg";